import { render, staticRenderFns } from "./BeosSwitchDemo.vue?vue&type=template&id=30cdd958"
import script from "./BeosSwitchDemo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BeosSwitchDemo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.109.2_postcss@8.5.26___lodash@4.18.1_vue_310aff08f8f5de83a6355c0e7868c558/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports